import styled from '@emotion/styled';

import {
  PrimaryTableRowDotted as BaseTableRowDotted,
  PrimaryTableRow as BaseTableRow,
} from '@Calix-Commerce/design-system/components';

import { accordionAnimation } from './accordionAnimation';

const LINE_ROW_LEFT_SPACING = '2rem';

export const CollapsibleRows = styled.tbody`
  ${accordionAnimation};

  tr:last-child > td {
    padding-bottom: 1.8rem;
  }
`;

export const SubRowDotted = styled(BaseTableRowDotted)`
  & > td:first-of-type {
    padding-left: ${LINE_ROW_LEFT_SPACING};
  }
`;

export const SubRow = styled(BaseTableRow)`
  td:first-of-type {
    padding-left: ${LINE_ROW_LEFT_SPACING};
  }
`;

export const ExtendedWarrantyTitle = styled.div`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const ExpandedChildRowSecondaryColumn =  styled.div`
  margin-left:-12px;
`
